import React, { useState } from 'react';
import { Button, Spin, Table, Alert } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { ReportFilter, ColorItem } from '../../services/p1314Api';
import { useP1314Report } from './hooks/useP1314Report';
import LookupField from '../../components/LookupField';

const P1314Report: React.FC = () => {
  const { loading, reportData, queried, noData, runQuery } = useP1314Report();

  const [codeStart, setCodeStart] = useState('');
  const [codeEnd, setCodeEnd] = useState('');

  const handleQuery = () => {
    const filter: ReportFilter = {
      code_start: codeStart || undefined,
      code_end: codeEnd || undefined,
    };
    runQuery(filter);
  };

  const columns: ColumnsType<ColorItem> = [
    { title: '色號代號', dataIndex: 'code', key: 'code', align: 'center', width: 80 },
    { title: '中文色名', dataIndex: 'name', key: 'name', width: 200, ellipsis: true },
    { title: '英文色名', dataIndex: 'english_name', key: 'english_name', width: 200, ellipsis: true },
    { title: '舊代號', dataIndex: 'old_code_flag', key: 'old_code_flag', width: 60, align: 'center',
      render: (v: boolean) => v ? '是' : '否' },
    { title: '備註', dataIndex: 'remarks', key: 'remarks', ellipsis: true },
  ];

  return (
    <Spin spinning={loading}>
      <div className="max-w-3xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">色號清冊 (pw1314f1)</h2>

        {/* Filter Panel */}
        <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
          <div className="flex flex-wrap items-center gap-3 mb-3">
            <span className="text-sm font-medium">色號代號:[從]</span>
            <LookupField
              lookupType="colorCode"
              value={codeStart}
              onChange={v => setCodeStart(v.toUpperCase())}
              style={{ width: 100 }}
              maxLength={3}
              title="色號查詢"
            />
            <span className="text-sm">[至]</span>
            <LookupField
              lookupType="colorCode"
              value={codeEnd}
              onChange={v => setCodeEnd(v.toUpperCase())}
              style={{ width: 100 }}
              maxLength={3}
              title="色號查詢"
            />
          </div>
          <div className="flex gap-2">
            <Button type="primary" icon={<SearchOutlined />} onClick={handleQuery}>
              查詢
            </Button>
          </div>
        </div>

        {/* Results */}
        {queried && !noData && reportData && (
          <div>
            <div className="mb-2 text-sm text-gray-500">
              共 {reportData.total} 筆色號資料
            </div>
            <Table<ColorItem>
              dataSource={reportData.items}
              columns={columns}
              rowKey="code"
              size="small"
              pagination={false}
              bordered
              scroll={{ x: 700 }}
            />
          </div>
        )}

        {/* BR-05: Empty result */}
        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無資料!"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default P1314Report;
